import React, { Component } from 'react'
import { KeypadOption, TagButtonStyle, TeamDropDown, Title, ToggleArea } from '../styles/dialpadstyle'
import SpinnerIcon from '../../../../common/components/SpinnerIcon'
import PropTypes from 'prop-types';
import Select from 'react-select-plus';
import {
  FormWrapper,
  FormColumn,
  FormGroup,
  ControlLabel,
  FormControl,
  Button
} from 'modules/theme';
import Toggle from 'react-toggle';
import moment from 'moment-timezone';
import Datetime from 'react-datetime';
import styled from 'styled-components';

const CallTagThemeWrapper = styled.div`

  // for selected option
  // .Select.Select--multi.is-clearable.is-searchable.has-value {
  //   overflow: hidden;
  // }

  .Select-value-label {
    white-space: break-spaces;
  }


  // for options in dropdown
  .Select-menu {
    overflow-x: hidden;
  }
  .Select-option {
    // white-space: break-spaces;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export class CallTagTheme extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dnc: false,
      callback: false,
      startDate: '',
      endDate: '',
      global: ''
    }
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  renderStartDate() {
    const { __ } = this.context;
    const { callBackDate, onDateChange } = this.props;
    const props = {
      initialValue: new Date(),
      input: true,
      inputProps: { placeholder: __('Select Start date') },
      timeFormat: 'HH:mm',
      dateFormat: 'YYYY/MM/DD',
      // closeOnSelect: true
    };

    return (
      <div>
        <Datetime
          {...props}
          value={callBackDate}
          onChange={date => onDateChange(date)}
        />
      </div>
    )
  }

  render() {
    let {
      title,
      dncType,
      onDncChange,
      onChangeSelect,
      tagValue,
      callTagFinalTag,
      optionsTag,
      onCommentChange,
      ButtonText,
      callState,
      isBack = true,
      isAutoDispose = false,
      handleAutoDisposeSnooze = () => {},
      onDoneClick } = this.props

    tagValue = tagValue || [];
    callTagFinalTag = callTagFinalTag || {};
    return (
      <CallTagThemeWrapper>

        <TagButtonStyle>
          <FormWrapper style={{display:"none"}}>
            <FormColumn style={{ paddingRight: '0px' }}>
              <ToggleArea>
                <Toggle
                  defaultChecked={this.state.dnc}
                  icons={{
                    checked: <span>Yes</span>,
                    unchecked: <span>No</span>
                  }}
                  onChange={this.onChange}
                  name="dnc"
                  id="dnc"
                  value={this.state.dnc}
                />
                <ControlLabel>DNC</ControlLabel>
              </ToggleArea>
            </FormColumn>
            <FormColumn>
              <ToggleArea>
                <Toggle
                  defaultChecked={this.state.callback}
                  icons={{
                    checked: <span>Yes</span>,
                    unchecked: <span>No</span>
                  }}
                  onChange={this.onChange}
                  name="callback"
                  id="callback"
                  value={this.state.callback}
                />
                <ControlLabel>CallBack</ControlLabel>
              </ToggleArea>
            </FormColumn>
          </FormWrapper>
          <Title>
            {title}
          </Title>
          <form>
            <TeamDropDown>
              <Select
                placeholder="Click here to Disposition Call"
                onChange={onChangeSelect}
                value={tagValue}
                options={optionsTag}
                multi={true}
                removeSelected={true}
              />
            </TeamDropDown>
            <KeypadOption>
              <span>
                <FormWrapper style={{display: callTagFinalTag.isCallback? '':'none'}} >
                  <FormColumn style={{ paddingRight: '5px' }}>{this.renderStartDate()}</FormColumn>
                </FormWrapper>
                <FormWrapper style={{ marginBottom: '10px', display: callTagFinalTag.isDnc? '':'none' }}>
                  <FormColumn style={{ paddingRight: '0px', textAlign: 'center' }}>
                    <FormControl
                      defaultChecked={false}
                      name="radio"
                      componentClass="radio"
                      value={this.state.global}
                      onChange={(e)=>{
                        onDncChange("global")
                      }}
                    >
                      {('Global')}
                    </FormControl>
                  </FormColumn>
                  <FormColumn style={{ textAlign: 'center' }}>
                    <FormControl
                      defaultChecked={true}
                      name="radio"
                      componentClass="radio"
                      value={this.state.team}
                      onChange={(e)=>{
                        onDncChange("team")
                      }}
                    >
                      {('Team')}
                    </FormControl>
                  </FormColumn>
                </FormWrapper>
              </span>
              <FormWrapper>
                <FormColumn>
                  {this.renderFormGroup('', {
                    defaultValue: '',
                    placeholder: 'Type your comment...',
                    autoFocus: false,
                    maxLength: 255,
                    elementType: "textarea",
                    required: true,
                    id: 'comment',
                    value: this.props.comment,
                    onChange: onCommentChange,
                    style: {
                      padding: "13px"
                    }
                  })}
                </FormColumn>
              </FormWrapper>
            </KeypadOption>

            {!isBack &&
              <div style={{"textAlign":"center"}}>
                {isAutoDispose && callTagFinalTag.isCallback && (
                  <Button
                    onClick={  ()=>{
                      handleAutoDisposeSnooze();
                    }}
                    btnStyle={"default"}
                    block
                    size="xl"
                    style={{
                      marginBottom: "10px",
                      background: "rgba(248, 234, 237, 0.8)",
                      color: "#818181",
                      textTransform: "capitalize",
                      padding: 6,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >
                    <span className="material-symbols-outlined mr-3">snooze</span>Snooze
                  </Button>
                )}
                <Button
                  onClick={ callState == "doneLoading" ? ()=>{
                    
                  } : ()=>{
                    onDoneClick("");
                  }}
                  btnStyle={"default"}
                  block
                  size="xl"
                  style={{
                    marginBottom: "10px",
                    background: "rgba(76, 185, 68, 0.2)",
                    color: "#4CB944",
                    textTransform: "capitalize"
                  }}
                >
                  { callState == "doneLoading" ? ( <SpinnerIcon/> ): ButtonText}
                </Button>
                <Button
                  onClick={ callState == "doneLoading" ? ()=>{
                    
                  } : ()=>{
                    onDoneClick("offline");
                  }}
                  btnStyle={"default"}
                  block
                  size="xl"
                  style={{
                  background: "rgba(232, 38, 70, 0.2)",
                  color: "#E34242",
                  textTransform: "capitalize"
                  }}
                >
                  { callState == "doneLoading" ? ( <SpinnerIcon/> ): "Disposition & Go Offline"}
                </Button>
              </div>
            }
          </form>
        </TagButtonStyle>
      </CallTagThemeWrapper>
    )
  }
}


CallTagTheme.contextTypes = {
  __: PropTypes.func
};

export default CallTagTheme


// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/CallTagTheme.js